import {
  useQuery,
  UseQueryOptions,
  UseQueryResult
} from "@tanstack/react-query";
import { AxiosError } from "axios";
import * as notifications from "../../../notifications/notifications";
import { networkKeys } from "../../samples/queryKeys";
import { IPReport } from "../@types";
import api from "../api";
import { USEQUERY_DISABLE_REFETCH_OPTIONS } from "../consts";

const { cloud_enabled: cloudEnabled } = window.tcbase.consts;

export const defaultIPReportQueryOptions = (
  ip: string
): UseQueryOptions<IPReport, AxiosError, IPReport> => ({
  queryKey: networkKeys.ipReport(ip),
  queryFn: () =>
    api
      .ipReport({ ip })
      .then((r: { data: IPReport }) => r.data)
      .catch((e: AxiosError) => {
        notifications.show({
          level: "error",
          message: `Error encountered while fetching IP Report data. (${
            e.message || e.toString()
          })`
        });
        throw e;
      }),
  placeholderData: prev => prev,
  enabled: Boolean(ip && cloudEnabled),
  retryOnMount: false,
  retry: false,
  ...USEQUERY_DISABLE_REFETCH_OPTIONS
});

const useNetworkThreatIntelIPReport = (
  ip: string
): UseQueryResult<IPReport, AxiosError> =>
  useQuery<IPReport, AxiosError>(defaultIPReportQueryOptions(ip));

export default useNetworkThreatIntelIPReport;
